import { useMemo } from 'react';
import type { ColumnsType } from 'antd/es/table';
import { useTranslation } from 'react-i18next';
import type { PortfolioRowViewModel } from '../OrganizationManagerDashboardPage.types';
import { businessImpactPillClass } from '../utils';

export function usePortfolioTableColumns(): ColumnsType<PortfolioRowViewModel> {
  const { t } = useTranslation('dashboard');

  return useMemo(
    () => [
      {
        title: t('portfolio.columns.location'),
        dataIndex: 'location',
        key: 'location',
        render: (value: string) => (
          <span className="om-portfolio-location">{value}</span>
        ),
      },
      {
        title: t('portfolio.columns.chargers'),
        dataIndex: 'chargersRating',
        key: 'chargers',
      },
      {
        title: t('portfolio.columns.ownership'),
        dataIndex: 'ownershipIssue',
        key: 'ownership',
      },
      {
        title: t('portfolio.columns.contractStatus'),
        dataIndex: 'contractStatus',
        key: 'contractStatus',
      },
      {
        title: t('portfolio.columns.businessImpact'),
        dataIndex: 'businessImpact',
        key: 'businessImpact',
        render: (impact: PortfolioRowViewModel['businessImpact']) => (
          <span className={businessImpactPillClass(impact)}>
            <span className="om-impact-pill__dot" aria-hidden />
            {t(`portfolio.impact.${impact}`)}
          </span>
        ),
      },
    ],
    [t],
  );
}
